'use client';

import { formatCurrency } from '@/features/orders/orderPresentation';
import './savedAmount.scss';

function computeGrossTotal(base = 0, saved = 0) {
  const amount = Number(saved || 0);
  const totalBase = Number(base || 0);

  return Math.max(0, totalBase + amount);
}

function computePercentSaved(saved = 0, base = 0) {
  const amount = Number(saved || 0);
  const gross = computeGrossTotal(base, amount);

  if (gross <= 0 || amount <= 0) {
    return 0;
  }

  return Math.min(100, Math.round((amount / gross) * 100));
}

export default function SavedAmount({
  savedAmount = 0,
  totalBase = 0,
  className = '',
  currency = 'USD',
  id,
  label = 'You save',
  showPercentage = true,
}) {
  const amount = Number(savedAmount || 0);
  const percentSaved = computePercentSaved(amount, totalBase);

  if (!amount || amount <= 0) {
    return null;
  }

  const amountLabel = formatCurrency(amount, currency);

  return (
    <div id={id} className={`savings-block ${className}`.trim()}>
      <div className="savings-block__content">
        <span>{label}</span>
        <span className="savings-block__amount">{amountLabel}</span>
        {showPercentage ? (
          <span className="savings-block__percentage">{percentSaved}%</span>
        ) : null}
        <span className="savings-block__emoji" aria-hidden>
          🎉
        </span>
      </div>
      <div className="visually-hidden" aria-live="polite">
        {amountLabel}
        {showPercentage ? ` (${percentSaved}%)` : ''}
      </div>
    </div>
  );
}
